module.exports = __webpack_public_path__ + "img/borders1.5b40742d.png";